/**
 * Identifies how the response to the request should be transmitted.
 * tag: 725
 * @readonly
 * @enum {number} (int)
 */
export enum ResponseTransportType {
  Inband = 0,
  OutOfBand = 1,
}
